import React from "react";
import Container from "./components/Container";
import Header from "./components/Header";

const App = () => {
  return <div style={{
    background: "#200122",  /* fallback for old browsers */
background: "-webkit-linear-gradient(to right, #6f0000, #200122)",  /* Chrome 10-25, Safari 5.1-6 */
background: "linear-gradient(to right, #6f0000, #200122)", /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  }} >
    <Header/>
    <Container/>
  </div>
};

export default App;